<template>
  <div v-if="tapsList.length" :class="['clarifications', {'_with-background': showBackground}]">
    <h4 v-if="withTitle" class="title">
      Уточнить:
    </h4>
    <div class="clarifications-list" @scroll="scrollHandler($event)">
      <button
        v-for="(item, index) of tapsList"
        :key="`clarification-${index}`"
        class="clarification-item"
        @click="clarificationClickHandler(item)"
        v-text="item.relatedSearch"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'clarifications-block',

  props: {
    withTitle: {
      type: Boolean,
      default: true,
    },
    hideDecoratorOnMobile: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showBackground: true,
  }),

  computed: {
    ...mapState({
      tapsList: (state) => state.taps,
    }),
  },

  mounted() {
    if (this.hideDecoratorOnMobile && window.innerWidth < 951) {
      this.showBackground = false;
    }
  },

  methods: {
    scrollHandler(evt) {
      if (evt.target.scrollLeft / (evt.target.scrollWidth - evt.target.clientWidth) === 1) this.showBackground = false;
      else if (!this.hideDecoratorOnMobile) this.showBackground = true;
    },
    clarificationClickHandler(clarification) {
      if (window.history.customPushState) {
        window.history.customPushState(
          { query: decodeURIComponent(clarification.relatedSearch) },
          null,
          decodeURIComponent(`/search/?query=${clarification.relatedSearch}`),
        );
      }

      this.$emit('setQuery', clarification.relatedSearch);
    },
  },
};
</script>

<style scoped lang="scss">
.clarifications {
  position: relative;
  display: flex;
  column-gap: 8px;
  width: 100%;
  overflow: auto;

  &._with-background:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(270deg, #FFFFFF 57.07%, rgba(255, 255, 255, 0) 100%);
    width: 50px;
    height: 100%;
  }

  .title {
    margin-top: 9px;
    font-size: 16px;
    line-height: 18px;
    font-weight: 700;
    color: #333332;
  }

  .clarifications-list {
    display: flex;
    column-gap: 8px;
    padding-bottom: 8px;
    overflow: auto;

    &::-webkit-scrollbar {
      height: 4px;
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 0;
      background: #eeeeee;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 50px;
      background: #E30613;
    }
  }

  .clarification-item {
    min-height: 0;
    padding: 9px 12px 11px;
    border: 1px solid #E30613;
    border-radius: 4px;
    background-color: #FFFFFF;
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
    color: #333332;
    white-space: nowrap;

    @media (max-width: 950px) {
      font-size: 16px;
      line-height: 18px;
    }
  }
}
</style>
